<template>
  <!-- 特别推荐 -->
  <div id="NonMember1">
    <div class="flRseniority_just">
    </div>
    <ul>
      <div class="title">
        特别推荐
      </div>
      <li
        v-for="(item,index) in NonMemberList"
        :key="index"
      >
        <i class="rig_bto_icon"></i>
        <span>
          <router-link
            :to="{name:'NonMemberdetail',query:{id:item.ContentID}}"
            v-html="item.Title"
          ></router-link>
        </span>
        <span>【{{item.AddDate}}】</span>
        <br>
        <!-- <div v-if="index == articleShow">{{item.Abstruct}}</div> -->
      </li>
    </ul>
		<el-pagination background class="r" @size-change="handleSizeChange" @current-change="handleCurrentPageChange" :current-page="page.currentPage" :page-sizes="page.sizes" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total"></el-pagination>
  </div>
</template>

<script>
import axios from 'axios'
import { pagination } from '../../../assets/mixin/data-table'
export default {
	name:'NonMember1',
	mixins: [pagination],
  data(){
    return{
      Lmurl:'http://cmcpa.boyuancb.com',
			NonMemberNav:'',
			NonMemberList:[],
    }
  },
  components:{

  },
  methods:{
		getInfo(){
      this.page.currentPage = 1;
      this.getTableData();
    },
    getTableData(){
			axios.post('/SiteContentAPI/GetPageList',{
				ChannelID:3427,
				JournalID:202007100001,
				CurrentPage:this.page.currentPage,
				PageSize:this.page.pageSize
			}).then((res) => {
				this.NonMemberList = res.data._itemList//党建学习
				this.page.total = res.data.totalRecords
				this.NonMemberList.forEach((item) => {
					item.AddDate = item.AddDate.substr(0,10)
					item.TitlePhoto = this.Lmurl + item.TitlePhoto
				})
			})
		},
		handleCurrentPageChange(val){
      this.page.currentPage = val;
      this.getTableData();
    },
  },
  created(){
    this.getInfo();
  }
}
</script>

<style lang="less" scoped>
  #NonMember1{
		width:100%;
		height:auto;
		margin: 0 auto;
		position: relative;
		margin-bottom:25px;
		.NonMemberNav{
			background:#F7F8FA;
			.periodiCon_cluster_Cont_right{
				p:nth-child(1){
					a{
						color:#C01B22;
					}
				}
			}
		}
		li:hover{
			background:#F7F8FA;
			.periodiCon_cluster_Cont_right{
				p:nth-child(1){
					a{
						color:#C01B22;
					}
				}
			}
		}
		li{
			list-style: none;
			width: 100%;
			height: 38px;
			// float: left;
			margin-right: 44px;
			cursor: pointer;
			padding:15px 9px;
			background:#F8F8F8;
			.periodiCon_cluster_Cont_img{
				width: 175px;
				height: 120px;
				float: left;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.periodiCon_cluster_Cont_right{
				width:678px;
				float: right;
				p:nth-child(1){
					width: 100%;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 1;
					line-clamp: 1;
          -webkit-box-orient: vertical;
					a{
						color: #333333;
						font-size: 18px;
					}
				}
				p:nth-child(2){
					width: 100%;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					line-clamp: 3;
					/*! autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
					color: #8B8B8B;
					font-size:16px;
					margin-top:7px;
          text-align:justify;
          // text-indent: 2em;
				}
				p:nth-child(3){
					width: 100%;
					height: 15px;
					margin-top: 9px;
					span:nth-child(1){
						color:#909090;
						font-size: 14px;
						float: left;
					}
					span:nth-child(2) a{
						color: #909090;
						font-size: 16px;
						float: right;
					}
				}
			}
		}
    .title {
      height: 60px;
      line-height: 60px;
      width: 100%;
      padding-left: 10px;
      font-size: 20px;
      font-weight: bold;
      color: #C01B22;
      border-bottom: 1px solid #E3E3E3;
    }
    ul {
      background:#F8F8F8;
      padding-left: 35px;
      padding-right: 20px;
      padding-top: 5px;
      padding-bottom: 20px;

    }
     ul {
        width: 100%;
        height: 100%;
        li {
          list-style: none;
          position: relative;
          .rig_bto_icon {
            width: 6px;
            height: 6px;
            background: #807E7E;
            position: absolute;
            border-radius: 50%;
            float: left;
            display: inherit;
            text-align: center;
            top: 23px;
            color: #fff;
            font-style: normal;
          }
          span:nth-child(2) {
            width: 79%;
            float: left;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            margin-left: 31px;
            a {
              color: #333333;
              font-size: 16px;
            }
          }
          span:nth-child(3) {
            float: right;
            color: #333333;
            font-size: 14px;
          }
          div {
            width: 78%;
            text-align: justify;
            color: #151515;
            font-size: 14px;
            margin-top: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            // text-indent: 2em;
            margin-left: 30px;
          }
        }
        li:hover {
          div {
            color: #c01b22;
          }
          span:nth-child(2) {
            a {
              color: #c01b22;
            }
          }
          span:nth-child(3) {
            color: #c01b22;
          }
        }
      }
	}
	/deep/.content_body_left_divC{
		margin-top: 0!important;
	}
	/deep/.el-pagination{
    position: absolute;
    bottom: -46px;
    width: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Themactive/NonMember2/index.vue